import { __assign, __awaiter, __generator } from 'tslib';
import { KpkApiFormFieldType, autocomplete } from '@keepeek/api-client';

function buildFormField(sheetField, thesaurusTreeView, required) {
    var fieldType = sheetField.type || KpkApiFormFieldType.Text;
    var baseFormField = {
        id: sheetField.id || "",
        title: sheetField.title || "",
        type: fieldType,
        forceSelection: sheetField.forceSelection || undefined,
        treeViewByDefault: thesaurusTreeView,
        required: required,
        description: sheetField.description
    };
    var value;
    switch (fieldType) {
        case KpkApiFormFieldType.Email:
        case KpkApiFormFieldType.URL:
        case KpkApiFormFieldType.Datetime:
        case KpkApiFormFieldType.Geo:
        case KpkApiFormFieldType.CheckBox:
            // these types of fields are not supported.
            // for example for field types "email" / "url", we must check the validity of data
            // before sending it to indexing otherwise it crashes.
            // Please update documentation after evolution
            // https://confluence.keepeek.com/display/RD/Couverture+fonctionnelle+-+focus+type+de+champ
            console.error("this form field is not implemented", sheetField.id, fieldType);
            return null;
        case KpkApiFormFieldType.Date:
            value = null;
            break;
        case KpkApiFormFieldType.MultipleList:
        case KpkApiFormFieldType.Thesaurus:
            value = [];
            break;
        default:
            value = "";
            break;
    }
    return __assign(__assign({}, baseFormField), { value: value });
}
var adaptThesaurusApiResult = function (apiTreeResult) {
    var _a;
    return ((_a = apiTreeResult === null || apiTreeResult === void 0 ? void 0 : apiTreeResult._embedded) === null || _a === void 0 ? void 0 : _a.child.map(function (t) {
        return {
            id: t.id || -1,
            label: t.title || "",
            childrenLoading: false
        };
    })) || [];
};
var convertToThesaurusOptions = function (kpkApiSearchAutocompleteResult) {
    var _a, _b;
    var result = [];
    if (kpkApiSearchAutocompleteResult) {
        (_b = (_a = kpkApiSearchAutocompleteResult._embedded) === null || _a === void 0 ? void 0 : _a.thesaurus) === null || _b === void 0 ? void 0 : _b.forEach(function (thesaurus) {
            var _a;
            if (thesaurus && thesaurus.id && thesaurus.title) {
                var breadcrumb = (_a = thesaurus._embedded) === null || _a === void 0 ? void 0 : _a.parent.map(function (parent) { return parent.title; });
                var breadcrumbWithoutFirstParent = breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.slice(1, breadcrumb.length - 1);
                breadcrumbWithoutFirstParent === null || breadcrumbWithoutFirstParent === void 0 ? void 0 : breadcrumbWithoutFirstParent.push(thesaurus.title);
                var label = breadcrumbWithoutFirstParent === null || breadcrumbWithoutFirstParent === void 0 ? void 0 : breadcrumbWithoutFirstParent.join(" > ");
                result.push({
                    id: thesaurus.id,
                    label: label || thesaurus.title
                });
            }
        });
    }
    return result;
};
function getAutocompleteResults(axiosInstance, query, thesaurusId) {
    return __awaiter(this, void 0, void 0, function () {
        var result, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, autocomplete(axiosInstance, {
                            q: query,
                            thesaurusId: thesaurusId,
                            type: ["thesaurus"]
                        })];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, convertToThesaurusOptions(result.data)];
                case 2:
                    err_1 = _a.sent();
                    console.error(err_1);
                    console.error("Can't autocomplete query ".concat(query));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, []];
            }
        });
    });
}

export { adaptThesaurusApiResult, buildFormField, convertToThesaurusOptions, getAutocompleteResults };
//# sourceMappingURL=utils.js.map
